import round from "../../utils/round";
import getNumber from "./get-number";

/**
 *
 * @param {IncrementProps} input
 * @param {Number} start
 * @param {Number} index
 */
const applyIncrement = (input, start, index) => {
  const operator = input.get("operator");
  const value = /** @type {String} */ (input.get("value"));
  const number = getNumber(value);

  switch (operator) {
    case "+":
      return round(start + number * index);

    case "-":
      return round(start - number * index);

    default:
      return start + number;
  }
}

export default applyIncrement;